// extracted by mini-css-extract-plugin
module.exports = {"name":"testimonial_name__e30dw","quote":"testimonial_quote__QGdY5"};